import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import { visit } from 'unist-util-visit'

// Custom rehype plugin to handle external links
const rehypeAddChainIcon = (options = {}) => {
    // External link hash, used to identify links that should open in a new tab
    const externalLinkHash = options.hash || '#external-link'

    // Chain link hash, used to identify links that should have the chain icon
    const chainLinkHash = options.chainHash || '#external-chain-link'

    return tree => {
        visit(tree, 'element', node => {
            if (node.tagName === 'a' && node.properties && node.properties.href) {
                const href = node.properties.href

                // Check if the URL contains either of the special hashes
                const hasExternalLinkHash = href.includes(externalLinkHash)
                const hasChainLinkHash = href.includes(chainLinkHash)

                // Process links that have either special hash
                if (hasExternalLinkHash || hasChainLinkHash) {
                    // Remove the hash from the href
                    if (hasExternalLinkHash) {
                        node.properties.href = href.replace(externalLinkHash, '')
                    } else if (hasChainLinkHash) {
                        node.properties.href = href.replace(chainLinkHash, '')
                    }

                    // Add target and rel attributes for all external links
                    node.properties.target = '_blank'
                    node.properties.rel = ['nofollow', 'noreferrer']

                    // Only add the chain icon for links with the chain link hash
                    if (hasChainLinkHash) {
                        // Add inline styles to ensure proper layout
                        node.properties.style = 'display: inline-flex; align-items: center;'

                        // Create the chain icon element
                        const iconElement = {
                            type: 'element',
                            tagName: 'img',
                            properties: {
                                src: 'https://cdn.ecomm-stg.dmgsecure.io/app/links.svg',
                                alt: 'External link',
                                style: 'margin-right: 5px; width: 16px; height: 16px;',
                            },
                            children: [],
                        }

                        // Add the icon as the first child
                        node.children.unshift(iconElement)
                    }
                }
            }
        })
    }
}

const SafeMarkdownContent = ({ content, className, style, externalLinkHash, externalChainLinkHash }) => {
    if (!content) return null

    return (
        <div className={className} style={style}>
            <ReactMarkdown
                rehypePlugins={[
                    [
                        rehypeAddChainIcon,
                        {
                            hash: externalLinkHash || '#external-link',
                            chainHash: externalChainLinkHash || '#external-chain-link',
                        },
                    ],
                ]}
            >
                {content}
            </ReactMarkdown>
        </div>
    )
}

SafeMarkdownContent.propTypes = {
    content: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    externalLinkHash: PropTypes.string, // Optional hash to identify links that should open in a new tab
    externalChainLinkHash: PropTypes.string, // Optional hash to identify links that should have the chain icon
}

export default SafeMarkdownContent
